import { useState, useEffect } from 'react'
import { getAvailableGamesForUnlock, unlockGameByReferral } from '../utils/referralService'
import './GameChoiceModal.css'

export default function GameChoiceModal({ user, onClose, onGameUnlocked }) {
  const [availableGames, setAvailableGames] = useState([])
  const [selectedGame, setSelectedGame] = useState(null)
  const [loading, setLoading] = useState(true)
  const [unlocking, setUnlocking] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadAvailableGames()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  async function loadAvailableGames() {
    if (!user) return
    
    setLoading(true)
    try {
      const games = await getAvailableGamesForUnlock(user.uid)
      setAvailableGames(games)
    } catch (err) {
      console.error('Error loading available games:', err)
      setError('Erro ao carregar jogos disponíveis')
    } finally {
      setLoading(false)
    }
  }

  async function handleUnlockGame() {
    if (!selectedGame || unlocking) return

    setUnlocking(true)
    setError(null)

    try {
      await unlockGameByReferral(user.uid, selectedGame)
      
      // Notifica sucesso
      if (onGameUnlocked) {
        onGameUnlocked(selectedGame)
      }
      
      // Fecha o modal
      setTimeout(() => {
        onClose()
      }, 2000)
    } catch (err) {
      console.error('Error unlocking game:', err)
      setError(err.message || 'Erro ao desbloquear jogo')
      setUnlocking(false)
    }
  }

  if (loading) {
    return (
      <div className="game-choice-overlay">
        <div className="game-choice-modal">
          <p>Carregando jogos disponíveis...</p>
        </div>
      </div>
    )
  }

  if (availableGames.length === 0) {
    return (
      <div className="game-choice-overlay">
        <div className="game-choice-modal">
          <h2>🎉 Parabéns!</h2>
          <p>Você já desbloqueou todos os jogos disponíveis!</p>
          <button onClick={onClose} className="close-btn">Fechar</button>
        </div>
      </div>
    )
  }

  return (
    <div className="game-choice-overlay">
      <div className="game-choice-modal">
        <div className="modal-header">
          <h2>🎁 Escolha seu Jogo!</h2>
          <p className="modal-subtitle">
            Você completou 5 indicações! Escolha um jogo para desbloquear gratuitamente:
          </p>
        </div>

        <div className="games-grid">
          {availableGames.map(game => (
            <div
              key={game.id}
              className={`game-card ${selectedGame === game.id ? 'selected' : ''}`}
              onClick={() => setSelectedGame(game.id)}
            >
              <div className="game-emoji">{game.emoji}</div>
              <div className="game-name">{game.name}</div>
              {selectedGame === game.id && <div className="check-mark">✓</div>}
            </div>
          ))}
        </div>

        {error && (
          <div className="error-message">
            ⚠️ {error}
          </div>
        )}

        {unlocking && (
          <div className="success-message">
            ✅ Jogo desbloqueado com sucesso!
          </div>
        )}

        <div className="modal-actions">
          <button
            onClick={handleUnlockGame}
            disabled={!selectedGame || unlocking}
            className="unlock-btn"
          >
            {unlocking ? '⏳ Desbloqueando...' : '🎮 Desbloquear Jogo'}
          </button>
          <button onClick={onClose} className="cancel-btn" disabled={unlocking}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}
